import { render, staticRenderFns } from "./cuTemplate.vue?vue&type=template&id=4d6c1f9f&scoped=true"
import script from "./cuTemplate.vue?vue&type=script&lang=js"
export * from "./cuTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c1f9f",
  null
  
)

export default component.exports